import type { FieldValues } from "react-hook-form";
import { FormComponent } from "../FormComponent";
import { FormDatePicker, type FormDatePickerProps } from "../fields/FormDatePicker";
import type { FormComponentProps } from "../types";

export type FormDateComponentProps<TFieldValues extends FieldValues> =
	FormComponentProps<TFieldValues> & Omit<FormDatePickerProps<TFieldValues>, "control">;

export const FormDateComponent = <TFieldValues extends FieldValues>(
	props: FormDateComponentProps<TFieldValues>,
) => {
	const { formMethods, ...restProps } = props;
	const { control } = formMethods;
	return (
		<FormComponent {...props}>
			<FormDatePicker control={control} {...restProps} />
		</FormComponent>
	);
};
